import { render } from "./AdminDernieresVisites.vue?vue&type=template&id=4b089797&scoped=true"
import script from "./AdminDernieresVisites.vue?vue&type=script&lang=js"
export * from "./AdminDernieresVisites.vue?vue&type=script&lang=js"

import "./AdminDernieresVisites.vue?vue&type=style&index=0&id=4b089797&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b089797"]])

export default __exports__